import Fetcher from "./FetchService";
import { toDTO } from "../components/shared/domainTypes/team.type";
// Private statics
const baseUrl = "/aviso/team/";
export default class TeamService {
    static getTeam(id) {
        return Fetcher.getSingleResponse(baseUrl + "getTeam", { id });
    }
    static saveTeam(team) {
        return Fetcher.postSingleResponse(baseUrl + "save", toDTO(team));
    }
}
